import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Scrolls the window to the top on every route change so every page loads
 * from the top — EXCEPT when the visitor is navigating with the browser's
 * back / forward button (nav type "POP"). In that case we defer to
 * useCatalogueScrollRestore, which restores the visitor to the exact scroll
 * position they left when they clicked into a product.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType === "POP") return;
    window.scrollTo(0, 0);
  }, [pathname, navType]);
  return null;
}
